module.exports = __webpack_public_path__ + "static/media/plus-icon.47a51919.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/plus-icon.svg
// module id = 2879
// module chunks = 0